import type { FaqEntry } from './en'

export const jaFaq: FaqEntry[] = [
{
    id: 'what-is-radiri',
    question: 'Radiriとは何ですか？',
    answer: `Radiriは、ある地域に住んでいるものの、その地域の主要言語を話さない人々に向けて、地域や地方のニュースを提供しています。私たちは正確な事実のみを報道しますが、記事の執筆やコンテンツの生成はAIが行っています。これにより、当社のオンライン新聞を月額わずか3ユーロという購読料で提供することが可能になっています。これは、ヨーロッパの伝統的で信頼できるサブスクリプション型新聞のデジタル版の一般的な購読料の10分の1から15分の1に相当します。`,
  },
  {
    id: 'why-radiri',
    question: 'なぜこのようなサービスを行っているのですか？',
    answer: `私たちは、地域や地方のニュースが過小評価されており、感情を煽るような世界的な出来事や地政学的なニュースの陰に隠れがちであると考えています。また、現地の言語による地域ニュースへのアクセスが限られている人々は、住んでいるコミュニティから疎外感を感じやすく、そのコミュニティからよそ者として扱われる可能性が高いとも考えています。ある地域の主要言語以外の言語で、定期的かつ信頼できる地域ニュースを報道することは、これまで経済的に成り立ちませんでしたが、私たちはAIの力を借りてそれを変えたいと考えています。`,
  },
  {
    id: 'ai-reliability',
    question: 'AIは作り話をすることがあると聞きました。あなたのニュースを信用してもいいのでしょうか？',
    answer:
      `私たちはAIをいくつかの目的で使用しています。情報源のコンテンツを事実報道、解説、意見などに分類するため。情報源のコンテンツを、報道されている出来事や事実ごとにグループ化するため。コピーや翻訳をせず、ターゲット言語でオリジナルの記事を執筆するため。そして、コンテンツを魅力的にし、新聞を読みやすくするために、鉛筆画や木炭画のような画像を生成するためです。

  当社のAIは、入力データを処理・要約し、入力データに厳密に基づいて記事を構成するためにのみ使用されます。ニュースの事実内容そのものを作り出すことは決してありません。`,
  },
  {
    id: 'data-sources',
    question: 'データはどこから取得していますか？',
    answer:
      `当社のシステムは、政府機関、博物館、企業などの公開ウェブサイトや、他の新聞など、ウェブ上で利用可能な発表やニュースを処理しています。また、政府機関や鉄道会社など、厳選された信頼できる情報源のソーシャルメディアアカウントも処理しています。`,
  },
  {
    id: 'price',
    question: 'なぜ無料でアクセスを提供できないのですか？',
    answer:
      `無料の新聞を提供するための唯一の方法は、広告を表示することです。私たちは読者を商品ではなく顧客であると考えているため、広告を表示することは決してありません。優れたジャーナリズムは、読者の考えに影響を与えようとする人々によってではなく、読者自身によって支払われるべきです。高品質な新聞が3ユーロというのは、信頼できるサブスクリプション型の新聞としては、既存のどのサービスと比較しても驚くほど低価格です。しかしながら、規模の経済が働くことで、将来的にはさらに価格を下げることができると私たちは信じています。`
  },
  {
    id: 'personal-data',
    question: '私に関するどのようなデータを収集しますか？',
    answer:
      `複数のデバイスから購読にアクセスでき、お客様が購読者であることを確認するために必要な最小限のデータのみを保存します。これには、お客様から提供された1つのメールアドレスが含まれます。これは、ボットや偽アカウントによる悪用を防ぐためでもあります。（もちろん、身元がわからないメールエイリアスを提供していただくことも可能です。）私たちはそのデータを誰とも共有しません。お客様が何を読み、何を検索し、何をクリックしたかに関するデータは一切収集しません。その理由は、広告を表示しないため、パーソナライズの必要がないからです。`
  },
  {
    id: 'political-bias',
    question: '政治的な偏りをどのように避けていますか？',
    answer:
      `当社のAIは、情報源と文章のスタイル（解説、専門家の意見、事実報道など）に基づいて、情報源のコンテンツの客観性の度合いを検出するように特別に設計されています。例えば、厳選された有名な博物館のページで見つかった新しい展覧会の発表は信頼できる事実とみなされますが、ニュースサイトに掲載されたインタビューで語られた意見は、インタビュー対象者によって発せられた意見とみなされます。個人やインフルエンサーによるソーシャルブログやソーシャルメディアの投稿は、原則として当社の情報源には一切含まれません。

私たちは、事実報道として検出された情報源のコンテンツに基づいてのみ記事を生成します。公に認められた情報源による解説が見つかった場合、当社のAIはそれを解説または意見として説明し、出典を明記した上で参考として含めることがあります。`
  },
  {
    id: 'copyright',
    question: '情報源の知的財産権をどのように保護していますか？',
    answer:
      `二重引用符で囲み、出典を明記した直接引用を除き、元の情報源のテキストをコピーしたり翻訳したりすることは決してありません。当社のAIは、情報源のコンテンツが事実報道であるか、解説、意見、文学作品であるかを検出するように特別に設計されており、記事で何を取り上げるかを決定する際には事実報道のみを含めます。当社のAIは、原文をコピーしたり翻訳したりするのではなく、それらの事実を入力として使用し、サポートする言語ごとに個別にオリジナルの記事を執筆します。`
  },
  {
    id: 'ai-generated-images',
    question: 'なぜAI生成画像を使用するのですか？',
    answer:
      `当社には専属のカメラマンはおらず、他人の画像を盗むこともしたくありません。伝統的なメディアと同様に、出版物は記事を補完するために象徴的な画像を使用します。例えば、火事の記事では必ずしも実際の現場ではなく、炎の画像が使われます。私たちはAIを使用して、これらの象徴的なビジュアルを倫理的かつ低コストで生成し、オリジナルの写真撮影やライセンス取得を必要とせずに、各記事の本質を捉えています。これらの画像が魅力的で役に立ち、時には楽しめるものであることを願っています。各画像に用意されているフィードバックボタンを使用して、ご感想をお聞かせください！`,
  },
]
